let tableHTML = `
  <div id="menu_slide">
    
        <div id="menu_btn">
<p>DRAG</p>
<div class="btn_container">

<div class="div_menu_button"></div>
<div class="div_menu_button"></div>
<div class="div_menu_button"></div>

        </div>
    </div>
    <table id="header">
    <thead>
      <tr>
      <td class="green big">Phase</td>
      <td class="green big">Work Package</td>
      <td class="green big">Item description</td>
      <td class="blue small">Assembly</td>
      <td class="blue small">Length</td>
      <td class="blue small">Qty</td>
      </tr>
    </thead>
  </table>
    <div class="dataContent">
        <table id="customers">
        <tbody>
        <!---->
      </tbody>
        </table>
    </div>

  </div>
`
let i = 0;
let tableWrap = document.createElement('div');
tableWrap.id = 'menu_wrapper'
tableWrap.innerHTML = tableHTML
document.body.appendChild(tableWrap)

let openBtn = document.querySelector('#sideMenuBtn')
let closeBtn = document.querySelector('#closeBtnContainer')
let menu = document.querySelector('#sideMenu')
let table = document.querySelector('#customers')

function tableTemplete() {
  let table = document.querySelector('#customers tbody')
  for (let i = 1; i < 201; i++) {
    let newRow = table.insertRow(-1);
    let cell_0 = newRow.insertCell(0);
    cell_0.classList.add('big')
    let cell_1 = newRow.insertCell(1);
    cell_1.classList.add('big')
    let cell_2 = newRow.insertCell(2);
    cell_2.classList.add('big')
    let cell_3 = newRow.insertCell(3);
    cell_3.classList.add('small')
    let cell_4 = newRow.insertCell(4);
    cell_4.classList.add('small')
    let cell_5 = newRow.insertCell(5);
    cell_5.classList.add('small')
  }
}

tableTemplete()

function tablePush(val) {
  i++
  table.rows[i].cells[4].textContent = Math.round(val) + ' mm';
}

function tablePop() {
  table.rows[i].cells[4].textContent = "";
  i--
}

var windowHeight_canvas = $(window).height();
var $MB = $('#menu_btn'),
    $M = $('#menu_slide'),
    $viewcube = $('#viewcube'),
    $header = $('.header'),
    $canvas_height = $('canvas'),
    $DOM = $(document),
    startAtY = 25, // CSS px
    endAtY = 500,  // CSS #menu height px
    clickedAtY,
    clickEventType= document.ontouchstart !== null ? 'mousedown' : 'touchstart',
    moveEventType = document.ontouchmove  !== null ? 'mousemove' : 'touchmove' ,
    endEventType  = document.ontouchend   !== null ? 'mouseup'   : 'touchend'  ;

$MB.on(clickEventType, function( e ) { 
  e.preventDefault();  
  clickedAtY  = e.pageY - $(this).offset().top + $header.height();
  if(clickEventType === 'touchstart'){
    clickedAtY = e.originalEvent.touches[0].pageY - $(this).offset().top;
  }
  
  $DOM.on(moveEventType, moveHandler)
      .on(endEventType, stopHandler);

});

function moveHandler( e ) {
  var posY = e.pageY - clickedAtY;
  if(moveEventType === 'touchmove') {
    posY = e.originalEvent.touches[0].pageY - clickedAtY - $header.height();
  }
  posY = Math.min( Math.max(0, posY), endAtY - startAtY);
  $M.css({top: posY});
  $canvas_height.css({marginTop: posY / 2});
  $canvas_height.css({marginBottom: posY * 2});
  $viewcube.css({top: posY  + 100});

}

function stopHandler() {
  $DOM.off(moveEventType, moveHandler)
      .off(endEventType,  stopHandler);
}

export { tablePush, tablePop}